export default __webpack_public_path__ + "static/media/M-large.a9d2628e.svg";